var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8Drapeau2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 8.5 6 A 1.50015 1.50015 0 0 0 7 7.5 L 7 42.5 A 1.50015 1.50015 0 1 0 10 42.5 L 10 33 L 41.5 33 A 1.50015 1.50015 0 0 0 42.699219 30.599609 L 34.375 19.5 L 42.699219 8.4003906 A 1.50015 1.50015 0 0 0 41.5 6 L 8.5 6 z M 10 9 L 38.5 9 L 31.300781 18.599609 A 1.50015 1.50015 0 0 0 31.300781 20.400391 L 38.5 30 L 10 30 L 10 9 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Drapeau2);
export default __webpack_public_path__ + "static/media/icons8-drapeau-2.f026b3569348b5183a9d77dc4e63f17b.svg";
export { ForwardRef as ReactComponent };